import { createNames } from "../../utils";
export const getAceHeaderSubmenuNames = (id) => {
    return createNames(id, 'ACE-HEADER-SUBMENU', 'TABS', 'ICON_WRAPPER', 'ICON');
};
//# sourceMappingURL=ace-header-submenu.get-names.js.map
